"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referendumInfo = referendumInfo;
exports.ReferendumInfoExtended = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _operators = require("rxjs/operators");

var _types = require("@plugnet/types");

var _util = require("@plugnet/util");

var _drr = require("../util/drr");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name ReferendumInfoExtended
 * @description
 * A [[ReferendumInfo]] with an additional `index` field
 */
class ReferendumInfoExtended extends _types.ReferendumInfo {
  constructor(value, index) {
    super(value);
    this._index = void 0;
    this._index = value instanceof ReferendumInfoExtended ? value.index : new _types.ReferendumIndex(index);
  }
  /**
   * @description Convenience getter, returns the referendumIndex
   */


  get index() {
    return this._index;
  }
  /**
   * @description Creates the JSON representation
   */


  toJSON() {
    return (0, _objectSpread2.default)({}, super.toJSON(), {
      index: this.index.toJSON()
    });
  }

}

exports.ReferendumInfoExtended = ReferendumInfoExtended;

function referendumInfo(api) {
  return index => {
    return api.query.democracy.referendumInfoOf(index).pipe((0, _operators.map)(optionInfo => {
      const info = optionInfo.unwrapOr(null);
      return new _types.Option(ReferendumInfoExtended, (0, _util.isNull)(info) ? null : new ReferendumInfoExtended(info, index));
    }), (0, _drr.drr)());
  };
}